export enum UserRoleType {
  Admin = 'Admin',
  Manager = 'Manager',
  User = 'User',
  Unauthorized = 'Unauthorized',
}

export const UserRoleTypeTranslations: {
  [key in UserRoleType]: string;
} = {
  [UserRoleType.Admin]: 'Administrator',
  [UserRoleType.Manager]: 'Leder',
  [UserRoleType.User]: 'Bruger',
  [UserRoleType.Unauthorized]: 'Uautoriseret',
};

export interface User {
  id: number;
  initials: string;
  employeeNumber: number;
  name: string;
  email: string;
  departmentId: number;
  internalTitleId: number;
  nearestManagerId: number;
  department?: Department;
  internalTitle?: InternalTitle;
  nearestManager?: User;
  courseRole: UserRoleType;
  timelogRole: UserRoleType;
  assetRole: UserRoleType;
  equipmentRole: UserRoleType;
}

export interface SimpleUserDTO {
  id: number;
  name: string;
  email: string;
}

export interface Department {
  id: number;
  departmentName: string;
  departmentNumber: number;
  displayName: string;
}

export interface InternalTitle {
  id: number;
  name: string;
}
export interface LogDTO {
  id: number;
  user: SimpleUserDTO;
  date: Date;
  type: LogType;
  action: ActionType;
  message: string;
  objectId: number;
}

export enum ActionType {
  Create = 'Opret',
  Delete = 'Slet',
  Update = 'Opdater',
  Message = 'Meddelelse',
}

export enum LogType {
  // Shared
  Department = 'Department',
  User = 'User',
  InternalTitle = 'InternalTitle',

  // Timelog
  Customer = 'Customer',
  Project = 'Project',
  RequisitionNumber = 'RequisitionNumber',
  TimelogSheets = 'TimelogSheets',
  TimelogSync = 'TimelogSync',

  // TrainingTracking
  Course = 'Course',
  CourseCategory = 'CourseCategory',
  CourseParticipant = 'CourseParticipant',
  CourseProgress = 'CourseProgress',
  CourseParticipantStatus = 'CourseParticipantStatus',
  Certificate = 'Certificate',
  CourseParticipantCertificateDeletion = 'CourseParticipantCertificateDeletion',
  CourseParticipantCertificateRequest = 'CourseParticipantCertificateRequest',
  NotificationController = 'NotificationController',
}

export interface UserDTO extends SimpleUserDTO {
  initials?: string;
  employeeNumber?: number;
  departmentId: number;
  internalTitleId: number;
  nearestManagerId?: number;

  department?: DepartmentDTO;
  internalTitle?: InternalTitleDTO;
  nearestManager?: SimpleUserDTO;

  courseRole: UserRoleTypeDTO;
  timelogRole: UserRoleTypeDTO;
  assetRole: UserRoleTypeDTO;
  equipmentRole: UserRoleTypeDTO;
}

export interface DepartmentDTO {
  id: number;
  departmentNumber: number;
  departmentName?: string;
  displayName?: string;
}

export interface InternalTitleDTO {
  id: number;
  name: string;
}

export enum UserRoleTypeDTO {
  Admin = 'Admin',
  Manager = 'Manager',
  User = 'User',
  Unauthorized = 'Unauthorized',
}
